/// <amd-module name="SuiteCommerce.FeaturedCategory.Common.InstrumentationHelper"/>
define("SuiteCommerce.FeaturedCategory.Common.InstrumentationHelper", ["require", "exports", "SuiteCommerce.FeaturedCategory.Instrumentation"], function (require, exports, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var QueueNameSuffix = '-FeaturedCategory';
    var ExtensionVersion = '1.3.0';
    var ComponentArea = 'SC Featured Category';
    var InstrumentationHelper = /** @class */ (function () {
        function InstrumentationHelper() {
        }
        InstrumentationHelper.initializeInstrumentation = function (environment) {
            Instrumentation_1.default.initialize({
                environment: environment,
                queueNameSuffix: QueueNameSuffix,
                defaultParameters: {
                    componentArea: ComponentArea,
                    extensionVersion: ExtensionVersion,
                }
            });
        };
        return InstrumentationHelper;
    }());
    exports.InstrumentationHelper = InstrumentationHelper;
});
